'use client';

import isEqual from 'lodash/isEqual';
import { useRef } from 'react';

/**
 * Returns a referentially stable version of `value`, updating only when the
 * value changes by deep equality. Useful for plain-data props (config objects,
 * option literals) that consumers may pass inline without memoising.
 *
 * Not suitable for values holding function references or class instances
 * (those compare false under deep-equal even when structurally identical) —
 * consumers must memoise such values themselves.
 */
export function useStableValue<T>(value: T): T {
  const ref = useRef(value);
  if (!isEqual(value, ref.current)) {
    ref.current = value;
  }
  return ref.current;
}
